__turbopack_context__.v({
  "root": "MobileSleepComponent-module__ammrQq__root",
});
